import { RouteObject } from 'react-router-dom'

// Routes
const userRoutes: RouteObject = {
  path: '/user',
  lazy: async () => {
    const { default: Component } = await import('@src/app/pages/user')
    return { element: <Component /> }
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/user/pages/home')
        return { element: <Component /> }
      }
    },
    {
      path: '/user/profile',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/user/pages/profile')
        return { element: <Component /> }
      }
    },
    {
      path: '/user/exams/:id/detail',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/user/pages/exam-detail')
        return { element: <Component /> }
      }
    },
    {
      path: '/user/exams/:id',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/user/pages/exam')
        return { element: <Component /> }
      }
    },
    {
      path: '/user/exams/:id/result',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/user/pages/exam-result')
        return { element: <Component /> }
      }
    },
    {
      path: '/user/exams/:id/history',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/user/pages/exam-history')
        return { element: <Component /> }
      }
    },
    {
      path: '/user/exams/:id/leaderboard',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/user/pages/exam-leaderboard')
        return { element: <Component /> }
      }
    },
    {
      path: '/user/regulations',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/user/pages/regulations')
        return { element: <Component /> }
      }
    },
    {
      path: '/user/documents',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/user/pages/documents')
        return { element: <Component /> }
      }
    },
    {
      path: '/user/documents/:slug',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/user/pages/documents/document-detail')
        return { element: <Component /> }
      }
    },
    {
      path: '/user/result-announcement',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/user/pages/result-announcement')
        return { element: <Component /> }
      }
    },
    {
      path: '/user/result-announcement/:slug',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/user/pages/result-announcement/result-announcement-detail')
        return { element: <Component /> }
      }
    },
    {
      path: '/user/huong-dan',
      lazy: async () => {
        const { default: ContentPageTemplate } = await import('@src/app/pages/user/lib/content-page-template')
        return { element: <ContentPageTemplate pageKey='guide' /> }
      }
    },
    {
      path: '/user/weekly-prizes',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/user/pages/weekly-prizes')
        return { element: <Component /> }
      }
    }
  ]
}

export default userRoutes
